// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__13bqR","Hr":"Home_Hr__2fplf","Hr2":"Home_Hr2__1y7VD","Hr3":"Home_Hr3__3ZfnR","tweets":"Home_tweets__tC3Ss"};